import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { Text } from '~/components/text/Text'
import { styled } from '~/styled'

import { INLINE_MESSAGE_ICONS } from './InlineMessage.config'
import { InlineMessageTheme } from './InlineMessage.types'

const InlineMessageContainer = styled('div', {
  base: ['flex'],
  variants: {
    theme: {
      success: ['text-success'],
      warning: ['[&_svg]:text-warning-dark', 'text-warning-text'],
      info: ['text-info'],
      neutral: ['text-grey-800'],
      error: ['text-danger']
    }
  }
})

type TInlineMessageProps = React.ComponentProps<
  typeof InlineMessageContainer
> & {
  showIcon?: boolean
  size?: 'xs' | 'sm' | 'md'
}

export const InlineMessage = ({
  className,
  showIcon = true,
  theme = 'error',
  size = 'sm',
  children,
  ...rest
}: TInlineMessageProps) => (
  <InlineMessageContainer theme={theme} className={className} {...rest}>
    {showIcon && (
      <Icon
        size="sm"
        is={INLINE_MESSAGE_ICONS[theme as InlineMessageTheme]}
        className="mr-2"
      />
    )}
    <Text as="span" size={size} className="translate-y-0.5">
      {children}
    </Text>
  </InlineMessageContainer>
)
